import { CommonFragments } from './common.fragments';

export class SummaryFragments {
  /*
   * GraphQL Fragment for the Summary Exhibit
   */
  public static readonly summaryFragment = `
    summaryExhibit {
      fundName
      asOfDate
      productCode
      isLiteratureSubscribable
      ${CommonFragments.literaturesFragment}
      ${CommonFragments.keyFactsFragment}
    }
  `;
}
